module.exports = __webpack_public_path__ + "static/flags/GV-946e46b2d04613143719d69f16362fa0.gif";